import { render, staticRenderFns } from "./supplier-add-or-update.vue?vue&type=template&id=735ea90a&scoped=true"
import script from "./supplier-add-or-update.vue?vue&type=script&lang=js"
export * from "./supplier-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./supplier-add-or-update.vue?vue&type=style&index=0&id=735ea90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ea90a",
  null
  
)

export default component.exports